import { DateTime } from "luxon";

//If the next day is Saturday (6) or Sunday (7), skip to Monday
export const getNextWeekDay = (date: DateTime): DateTime => {
  let nextDay = date.plus({ days: 1 });

  if (nextDay.weekday === 6) {
    nextDay = nextDay.plus({ days: 2 });
  } else if (nextDay.weekday === 7) {
    nextDay = nextDay.plus({ days: 1 });
  }

  return nextDay;
};
